import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ step }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  useEffect(() => {
    if (step !== undefined) {
      window.scrollTo({
        top: 150,
        behavior: "smooth",
      });
    }
  }, [step]);

  return null;
};

export default ScrollToTop;
